import React from "react";
import styled from "styled-components";
import classNames from "classnames";
import { Nav } from "react-bootstrap";
import MenuItemDesktop from "./MenuItemDesktop";


export default styled(({ menu = [], onClose, selected, onSelect, className = '', height }) => {

    return (
        <Nav className={classNames("d-none d-lg-flex flex-grow-1 h-100 justify-content-between", className, {"is-open" : Boolean(selected)})}>

            {menu.map((item, index) => (
                <MenuItemDesktop
                    key={index}
                    text={item.name}
                    select={onSelect}
                    onClose={onClose}
                    item={item}
                    height={height}
                />
            ))}

        </Nav>
    );
})`
margin-left: 2rem;

&.is-open {
    .site-nav {
        transform: scaleY(1);
        transition: none;
    }
}
.is-focused {
    .site-nav {
        opacity: 1;
        visibility: visible;
        transform: scaleY(1);
        transition: transform .25s ease, opacity 0ms, visibility 0ms;
    }
}

@media(max-width: 1290px){
    margin-left: 1rem;
}

@media(max-width: 1090px){
    margin-left: .5rem;
}
`;
